(() => {
  'use strict';

  // K80: Germany only. Rates and insurance weight boundary match C's Lauf 37 table.
  const SHIPPING = {
    country: 'DE',
    currency: 'EUR',
    bagGrams: 1050,
    minBags: 1,
    maxBags: 200,
    maxUninsuredGoodsGrams: 8700,
    insuranceCents: 699,
    classes: [
      { key: '5', maxGoodsGrams: 4000, cents: 769 },
      { key: '10', maxGoodsGrams: 8500, cents: 1049 },
      { key: '20', maxGoodsGrams: 18500, cents: 1899 },
      { key: '31.5', maxGoodsGrams: 30000, cents: 2399 }
    ]
  };

  function shippingQuote(bags) {
    if (!Number.isInteger(bags) || bags < SHIPPING.minBags || bags > SHIPPING.maxBags) return null;
    const goodsGrams = bags * SHIPPING.bagGrams;
    const top = SHIPPING.classes[SHIPPING.classes.length - 1];
    const parcels = [];
    let remaining = goodsGrams;
    function addParcel(tier, grams) {
      const insured = grams > SHIPPING.maxUninsuredGoodsGrams;
      parcels.push({
        classKey: tier.key,
        goodsGrams: grams,
        insured,
        cents: tier.cents + (insured ? SHIPPING.insuranceCents : 0)
      });
    }
    while (remaining > top.maxGoodsGrams) {
      addParcel(top, top.maxGoodsGrams);
      remaining -= top.maxGoodsGrams;
    }
    if (remaining > 0) {
      const tier = SHIPPING.classes.find(item => remaining <= item.maxGoodsGrams);
      addParcel(tier, remaining);
    }
    return {
      goodsGrams,
      cents: parcels.reduce((sum, parcel) => sum + parcel.cents, 0),
      boxes: parcels.length,
      parcels
    };
  }
  const state = () => {
    const node = document.querySelector('[data-cebe-b2b-cart-state]');
    if (!node) return { blocked: false, business: false, quantity: 0 };
    const quantity = Number(node.dataset.quantity), addons = Number(node.dataset.addons || 0), retail = Number(node.dataset.retail);
    const business = quantity + addons > 0;
    const message = node.dataset.approved !== 'true' ? node.dataset.accessMessage : retail > 0 ? node.dataset.mixedMessage : '';
    return { blocked: business && !!message, business, quantity, message, label: business ? node.dataset.businessLabel : node.dataset.retailLabel };
  };
  function sync() {
    const s = state();
    document.querySelectorAll('[data-cebe-checkout]').forEach(button => {
      const label = button.querySelector('.cebe-stateful__label');
      if (label && s.label && label.textContent !== s.label) label.textContent = s.label;
      if (s.blocked) {
        if (!button.disabled) button.disabled = true;
        button.dataset.cebeB2bBlocked = 'true';
      } else if (button.dataset.cebeB2bBlocked === 'true') {
        button.disabled = false;
        delete button.dataset.cebeB2bBlocked;
      }
    });
    document.querySelectorAll('[data-cebe-express]').forEach(node => { if (s.business && !node.hidden) node.hidden = true; });
    document.querySelectorAll('[data-cebe-b2b-cart-error]').forEach(node => {
      if (node.textContent !== (s.message || '')) node.textContent = s.message || '';
      if (node.hidden !== !s.blocked) node.hidden = !s.blocked;
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const checkout = form.matches('[data-cebe-checkout-form]') || event.submitter?.matches('[data-cebe-checkout]');
    if (checkout && state().blocked) {
      event.preventDefault(); event.stopImmediatePropagation(); sync();
      const error = document.querySelector('[data-cebe-b2b-cart-error]');
      if (error) { error.tabIndex = -1; error.focus(); }
    }
  }, true);
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; sync(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'disabled', 'data-quantity', 'data-addons', 'data-retail', 'data-approved'] });
  sync();
  document.querySelectorAll('[data-cebe-b2b-shipping]').forEach(panel => {
    const input = panel.querySelector('[data-cebe-b2b-shipping-quantity]');
    const strings = JSON.parse(panel.querySelector('[data-cebe-b2b-shipping-strings]').textContent);
    const error = panel.querySelector('[data-cebe-b2b-shipping-error]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: SHIPPING.currency });
    function update() {
      const n = Number(input.value);
      const quote = shippingQuote(n);
      if (!quote) {
        const message = n > SHIPPING.maxBags ? strings.limit : strings.invalid;
        error.textContent = message; error.hidden = false; input.setCustomValidity(message);
        panel.querySelector('[data-cebe-b2b-shipping-price]').textContent = '';
        panel.querySelector('[data-cebe-b2b-shipping-parcels]').textContent = '';
        return;
      }
      input.setCustomValidity(''); error.textContent = ''; error.hidden = true;
      panel.querySelector('[data-cebe-b2b-shipping-price]').textContent = money.format(quote.cents / 100);
      panel.querySelector('[data-cebe-b2b-shipping-parcels]').textContent = strings.parcels.replace('[count]', String(quote.boxes));
    }
    input.addEventListener('input', update);
    update();
  });
})();
